<template>
  <d2-container>
    <template slot="header">
       <el-form :inline="true" class="demo-form-inline">
         <el-form-item label="关键词">
           <el-input
               v-model="listQuery.keyword"
               size="small"
               placeholder="请输入关键词"
               style="width: 200px"
               @keyup.enter.native="getSearch()"
           >
           </el-input>
         </el-form-item>
         <el-form-item label="状态">
           <el-select
               v-model="listQuery.status"
               size="small"
               placeholder="请选择状态"
               style="width: 200px"
               @change="getSearch()"
               clearable
           >
             <el-option
                 :key="0"
                 label="已下架"
                 :value="0"
             ></el-option>
             <el-option
                 :key="1"
                 label="已上架"
                 :value="1"
             ></el-option>
           </el-select>
         </el-form-item>
         <el-form-item label="分类">
           <el-select
               v-model="listQuery.categoryId"
               size="small"
               placeholder="请选择分类"
               style="width: 200px"
               @change="getSearch()"
               clearable
           >
             <el-option
                 v-for="item in categoryOptions"
                 :key="item.key"
                 :label="item.value"
                 :value="item.key"
             ></el-option>
           </el-select>
         </el-form-item>
         <el-form-item >
           <el-button
               type="primary"
               size="small"
               icon="el-icon-search"
               @click="getSearch()"
           >搜索</el-button>
         </el-form-item>
       </el-form>

      <el-button
        class="filter-item"
       type="primary"
        size="mini"
       icon="el-icon-circle-plus"
       @click="add"
    >添加</el-button>
    <!-- 批量添加 -->
    <el-button
      class="filter-item"
      type="success"
      size="mini"
      icon="el-icon-circle-plus"
      @click="batchAdd"
    >批量添加</el-button>
    </template>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style="margin-top: 20px"
      :data="keywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="封面">
        <template slot-scope="scope">
          <el-image :src="scope.row.cover" :preview-src-list="[scope.row.cover]" style="width: 80px; height: 80px; object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="描述">
        <template slot-scope="scope">
          <span>{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0">下架</el-tag>
          <el-tag v-if="scope.row.status === 1">上架</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
              size="small"
              type="primary"
              @click="updateStatus(scope.row.id, scope.row.status)"
              style="margin-top: 10px;"
          >{{scope.row.status === 0 ? '上架' : '下架'}}</el-button>
          <el-button
              size="small"
              type="danger"
              @click="deleteCard(scope.row.id)"
              style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
    <!-- 批量添加弹窗 -->
    <el-dialog
      title="批量添加"
      :visible.sync="batchAddDialogVisible"
      width="60%"
    >
      <el-form :model="batchAddForm" :rules="rules" ref="batchAddForm" label-width="200px">
        <el-form-item label="工作流" prop="workflowId">
          <!-- 单选按钮 -->
          <el-radio-group v-model="batchAddForm.workflowId">
            <el-radio v-for="item in workflowOptions" :key="item.id" :label="item.id" :value="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类" prop="categoryId">
          <el-select v-model="batchAddForm.categoryId" placeholder="请选择分类">
            <el-option v-for="item in categoryOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="batchAddForm.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="batchAddForm.description" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item label="样图/场景图" prop="imgs">
          <upload-image v-model="batchAddForm.imgs"
          :text="['可批量选取', '图片格式png/jpg/webp/svg/tiff', '图片大小100MB以内']"
          :max="100"></upload-image>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchAddDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="batchAddConfirm">确定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>

import {
  deleteWorkflowTheme,
  downWorkflowTheme,
  getWorkflowList, getWorkflowThemeCategoryOptions,
  getWorkflowThemeList, upWorkflowTheme,
  upWorkflowThemeCategory,
  batchAddWorkflowTheme
} from '@/api/merchant/service/project'

import uploadImage from '@/components/uploadImage'

export default {
  name: 'comfyuiTheme',
  components: {
    uploadImage
  },
  data () {
    return {
      workflowOptions: [],
      batchAddDialogVisible: false,
      categoryOptions: [],
      batchAddForm: {
        workflowId: '',
        categoryId: '',
        name: '',
        description: '',
        imgs: []
      },
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      keywordList: [],
      categoryOptions: [],
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        categoryId: '', // 名称
        keyword: '',
        status: null
      },
      listLoading: false,
      rules: {
        workflowId: [
          {
            required: true,
            message: '请选择工作流',
            trigger: 'blur'
          }
        ],
        categoryId: [
          {
            required: true,
            message: '请选择分类',
            trigger: 'blur'
          }
        ],
        cover: [
          {
            required: true,
            message: '请选择封面',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入描述',
            trigger: 'blur'
          }
        ],
        imgs: [
          {
            required: true,
            message: '请选择样图/场景图',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
    this.getWorkflowThemeCategoryOptions()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path == '/merchant/service/product/comfyuiTheme' && from.path == '/merchant/service/project/aigcTheme') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },
  methods: {
    getWorkflowThemeCategoryOptions () {
      getWorkflowThemeCategoryOptions().then(res => {
        this.categoryOptions = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    deleteCard (id) {
      this.$confirm('此操作将永久删除该主题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteWorkflowTheme(id).then(res => {
            // 提示删除成功
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getSearch()
          })
        })
        .catch()
    },
    updateStatus (id, status) {
      if (status === 0) {
        upWorkflowTheme(id).then(res => {
          // 提示上架成功
          this.$message({
            message: '上架成功',
            type: 'success'
          })
          this.getSearch()
        })
      } else {
        downWorkflowTheme(id).then(res => {
          // 提示下架成功
          this.$message({
            message: '下架成功',
            type: 'success'
          })
        })
      }
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getWorkflowThemeList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.keywordList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.$router.push({
        path: '/merchant/service/project/aigcTheme'
      })
    },
    batchAdd () {
      this.batchAddForm = {
        workflowId: '',
        categoryId: '',
        cover: '',
        name: '',
        description: '',
        imgs: []
      }
      getWorkflowList().then(res => {
        this.workflowOptions = res
      })
      getWorkflowThemeCategoryOptions().then(res => {
        this.categoryOptions = res
      })
      this.batchAddDialogVisible = true
    },
    batchAddConfirm () {
      this.$refs.batchAddForm.validate((valid) => {
        if (valid) {
          batchAddWorkflowTheme(this.batchAddForm).then(res => {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.getSearch()
            this.batchAddDialogVisible = false
          })
        }
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/merchant/service/project/aigcTheme?id=' + id
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
